require('vendor/assets/javascripts/flux-dispatchr/BaseStore');
require('resources/resource_modal')

Resources     = LP.module('Resources')
ResourceModal = Resources.ResourceModal

class ResourceStore extends FluxBaseStore
  @storeName: 'ResourceStore'

  @handlers:
    SHOW_RESOURCE: 'show'
    HIDE_RESOURCE: 'hide'

  show: ({url, transition, type}) ->
    return if !url? || String(type) != 'resource'
    new ResourceModal(url, transition).show()

  hide: ->
    ResourceModal.hide()

Resources.ResourceStore = ResourceStore
